<template>
    <div class="club-step">
        <div class="club-step__logo">
            <img
                src="https://www.gibbstonvalley.com/assets/Hero/Sustainability/Logos-Brand/logo-gv-gold2x-v2.png"
                class="logo"
            />
        </div>
        <Navigation :activeStep="activeStep" />
        <div class="club-step__main">
            <p class="fancy-title">Wine club</p>
            <div class="club-step__main-container">
                <slot name="main"></slot>
            </div>
            <Actions :actions="actions" />
        </div>
    </div>
</template>
<script>
import Navigation from "../components/Navigation.vue";
import Actions from "../components/Actions.vue";
export default {
    name: "Step",
    components: {
        Navigation,
        Actions,
    },
    props: {
        activeStep: {
            type: Number,
            default: 0
        },
        actions: {
            type: Array,
        }
    }
}
</script>
